// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import
import { routes as dashboard } from './dashboard'

import { routes as company } from './company'
import { routes as bulkCampaign } from './bulk_campaign'
import { routes as recipient } from './recipient'
import { routes as campaign } from './campaign'
import { routes as report } from './report'
import { routes as setting } from './setting'
import { routes as scenario } from './scenario'
import { routes as leaderboard } from './leaderboard'
import { routes as laggards } from './laggards'
import { routes as managementreport } from './managementreport'
import { routes as adn } from './adn'
import { routes as vcro } from './vcro'
import { routes as HRISandVSMS } from './HRISandVSMS'
import { routes as gamification } from './gamification'
import { routes as userportalpages } from './userportalpages'
import { routes as ip } from './ip'
import { routes as teamportalpages } from './teamportalpages'
import { routes as logs } from './logs'
import { routes as adobeAcrobat } from './adobeAcrobat'
import { routes as adminlogs } from './adminlogs'
// https://developer.mozilla.org/pt-BR/docs/Web/JavaScript/Reference/Operators/Spread_operator
// Thus a new array is created, containing all objects that match the routes.
// ...dashboard must be the last one because of the catchall instruction

export default [...company, ...recipient, ...campaign, ...bulkCampaign,...report,...setting, ...scenario, ...laggards, ...dashboard, ...leaderboard, ...adn,...managementreport, ...vcro, ...HRISandVSMS, ...gamification,...userportalpages, ...teamportalpages,...ip,...logs,...adobeAcrobat,...adminlogs]




// WEBPACK FOOTER //
// ./src/app/routes.js